import {Component, Inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FinishProfileItem} from "../../product-details/interface/finish-profile-item-list";
import {FinishProfile} from "../../product-details/interface/finish-profile";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {PipeModule} from "../../pipe/pipe.module";

@Component({
	selector: 'fb-product-finish-profile-dialog',
	standalone: true,
	imports: [CommonModule, PipeModule],
	templateUrl: './product-finish-profile-dialog.component.html',
	styleUrls: ['./product-finish-profile-dialog.component.scss']
})
export class ProductFinishProfileDialogComponent {

	public selectedCurrency: ApCurrency = ApCurrency.INR;
	public totalFinishPrice: number = 0;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {
			selectedFinishes: FinishProfileItem[],
			finishProfile: FinishProfile
		},
		public dialogRef: MatDialogRef<ProductFinishProfileDialogComponent>,
		private _currencyResolver: CurrencyResolverService
	) {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		if(this.data.selectedFinishes.length > 0) {
			this._shiftSelectedFinishToTop();
			this.data.selectedFinishes.forEach((finish: FinishProfileItem) => {
				this.totalFinishPrice += finish.price;
			});
		}
	}
	private _shiftSelectedFinishToTop(): void {
		this.data.finishProfile.finishProfileItemList = this.data.finishProfile.finishProfileItemList.sort((a, b) => {
			if(this.data.selectedFinishes.includes(a)) {
				return -1;
			}
			else if(this.data.selectedFinishes.includes(b)) {
				return 1;
			}
			else {
				return 0;
			}
		});
	}

	public toggleFinish(finish: FinishProfileItem): void {
		if(!this.data.selectedFinishes.includes(finish)) {
			this.data.selectedFinishes.push(finish);
			this.totalFinishPrice += finish.price;
		}
		else {
			const index = this.data.selectedFinishes.indexOf(finish, 0);
			this.data.selectedFinishes.splice(index, 1);
			this.totalFinishPrice -= finish.price;
		}
	}

	public onClose(proceed: boolean): void {
		if(proceed)
			this.dialogRef.close(this.data.selectedFinishes);
		else
			this.dialogRef.close([]);
	}
}
